import React, { useEffect } from 'react'

import type { AppProps } from 'next/app'
import { NextSeo } from 'next-seo'
import { ThemeProvider } from 'styled-components'

import { InternationalizationProvider } from '@/store/internationalization'
import { PageContextProvider } from '@/store/pageContext'
import { ScreenProvider } from '@/store/screen'
import { SmoothScrollProvider } from '@/store/smoothScroll'
import { ResetStyle } from '@/styles/base'
import { defaultTheme } from '@/styles/themes'

const App = ({ Component, pageProps }: AppProps) => {
  useEffect(() => {
    const { body } = document

    const observer = new MutationObserver((mutationList) => {
      mutationList.forEach((mutation) => {
        if (mutation.type === 'childList') {
          const addedNodes = Array.from(mutation.addedNodes)
          const rdIframe = addedNodes.find(
            (node) =>
              node.nodeName === 'IFRAME' &&
              (node as Element).getAttribute('id') === 'rd_tmgr',
          )

          if (rdIframe) {
            const iframe = rdIframe as HTMLIFrameElement
            iframe.setAttribute('title', 'RD Station Iframe')

            observer.disconnect()
          }
        }
      })
    })

    observer.observe(body, {
      childList: true,
    })

    return () => {
      observer.disconnect()
    }
  }, [])

  return (
    <ThemeProvider theme={defaultTheme}>
      <ScreenProvider>
        <InternationalizationProvider>
          <PageContextProvider>
            <SmoothScrollProvider>
              <NextSeo
                title="Nata House"
                description="A short description goes here."
              />
              <Component {...pageProps} />
              <ResetStyle />
            </SmoothScrollProvider>
          </PageContextProvider>
        </InternationalizationProvider>
      </ScreenProvider>
    </ThemeProvider>
  )
}

export default App
